<template>
  <div>
    <!-- 普检复检单 精检复检单-->
    <!-- generalInspectionReinspectionList:'普检复检单',
        fineRetestList:'精检复检单', -->
    <el-dialog :title="type" :close-on-click-modal="false" :visible.sync="$parent.reinspectionDialogVisible"
      width="1800px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <li class="flex05">NO</li>
            <!--  店铺信息-->
            <li class="flex15">
              {{ $t("message.storeInformation") }}
            </li>
            <!-- 照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--OPTION  -->
            <li class="flex2">OPTION</li>
            <!--交易号数量  -->
            <li>{{ $t("message.numberOfTransactionNumbers") }}</li>
            <!-- 需复检商品数 -->
            <li>{{ $t("message.numberOfGoodsToBeReinspected") }}</li>

            <!-- 价格 -->
            <li>{{ $t("message.price") }}</li>
            <!-- 物流号 -->
            <li class="flex2">{{ $t("message.logisticsNumber") }}</li>

            <!-- 业务员商品备注 -->
            <li class="flex15">
              {{ $t("message.salesmanCommodityRemarks") }}
            </li>
            <!-- 采购商品备注 -->
            <li class="flex15">
              {{ $t("message.remarksForPurchasedCommodities") }}
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              {{ $t("message.verifierSNotes") }}
            </li>
          </ol>
          <!-- 无数据显示 -->
          <div class="noData" v-if="list == false">暂无数据</div>
          <!-- 订单详情 -->
          <div class="itemDetail" v-for="(item, index) in list" :key="index">
            <!--  -->
            <div class="infoBox">
              <!--  付款时间 -->
              <div class="info time">
                <!-- 客户付款时间 -->
                <p>{{ $t("message.customerPaymentTime") }}</p>
                {{ item.order_time_node.datetime_pay_confirm }}
              </div>
              <!-- 订单号 -->
              <div class="info">
                <p>
                  <router-link :to="'orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                    {{ item.order_sn }}
                  </router-link>
                </p>
                <p>{{ item.user.realname }}</p>
              </div>
              <!-- 交易号  -->
              <div class="info" style="line-height: 40px">
                <span>
                  {{ $t("message.transactionNumber") }}：
                  <a href="javascripr:;" class="a-link">
                    {{ item.purchase_no }}</a>
                </span>
              </div>
              <div class="info name">
                <!-- 业务 -->
                <span>{{ $t("message.business") }}：{{
                  item.y_admin.realname
                }}</span>
                <!--  采购-->
                <span>{{ $t("message.purchase") }}：{{
                  item.g_admin.realname
                }}</span>
                <!-- 配货 -->
                <span>{{ $t("message.distribution") }}：{{
                  item.p_admin.realname
                }}</span>
              </div>
            </div>
            <ul v-for="(items, indexs) in item.inspect_detail" :key="indexs">
              <!-- 订单号 -->
              <li class="flex15">
                <router-link :to="'orderPaymentDetail?order_sn=' + items.order_purchase.order_detail.order_sn"
                  target="_blank" class="a-link">
                  {{ items.order_purchase.order_detail.order_sn }}
                </router-link>
              </li>
              <!-- 番号 -->
              <li class="flex05">{{ items.order_purchase.order_detail.sorting }}</li>
              <li class="flex05">
                {{ indexs + 1 }}
              </li>

              <!--  店铺信息-->
              <li class="flex15">
                <div>
                  <p>{{ items.order_purchase.order_detail.shop_name }}</p>
                  <p>{{ items.order_purchase.order_detail.from_platform }}</p>
                  <p>{{ items.order_purchase.order_detail.shop_id }}</p>
                </div>
              </li>
              <!--照片-->
              <li>
                <div>
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="items.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                      <a :href="`https://detail.1688.com/offer/${items.order_purchase.order_detail.goods_id}.html`"
                        target="_blank" slot="reference">
                        <img :src="items.order_purchase.order_detail.pic" alt="" />
                      </a>
                    </el-popover>
                  </div>
                </div>
              </li>
              <!-- 商品属性 -->
              <li class="flex15">
                <div class="template">
                  <p v-for="(skuItem, skuIndex) in items.order_purchase
                    .order_detail.detail_y" :key="skuIndex">
                    <span>{{ skuItem.key }}:</span>
                    <span>{{ skuItem.value }}</span>
                  </p>
                </div>
              </li>

              <!--OPTION  -->
              <li class="flex2">
                <div class="template">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.order_purchase
                        .order_detail.option" :key="optiIndex" style="margin-bottom: 3px">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 100px">
                      <div class="row" v-for="(opti, optiIndex) in items.order_purchase
                        .order_detail.option" :key="optiIndex">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 交易号数量  -->
              <li>
                <div class="template">
                  <!-- 可入库 -->
                  <p>
                    {{ $t("message.canBePutIntoStorage") }}:{{
                      items.order_purchase.possible_num
                    }}
                  </p>
                  <!-- 已到货 -->
                  <p>
                    {{ $t("message.itHasArrived") }}:{{
                      items.order_purchase.storage_num
                    }}
                  </p>
                  <!-- 在库 -->
                  <!-- <p>
                    {{ $t("message.inStock") }}:{{
                      items.order_purchase.order_detail.stock_num
                    }}
                  </p> -->
                </div>
              </li>
              <!-- 需复检商品数 -->
              <li>
                <el-input v-model="items.reinspection_num" type="number"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" onfocus="this.select()"></el-input>
              </li>

              <!-- 价格 -->
              <li>{{ items.order_purchase.order_detail.confirm_price }}</li>
              <!-- 物流号 -->
              <li class="flex2">
                <div>
                  <p v-for="express in items.order_purchase
                    .order_purchase_express" :key="express.id">
                    {{ express.express_no }}
                  </p>
                </div>
              </li>

              <!-- 业务员商品备注 -->
              <li class="flex15">
                {{ items.order_purchase.order_detail.y_remark }}
              </li>
              <!-- 采购商品备注 -->
              <li class="flex15">
                {{ items.order_purchase.order_detail.g_remark }}
              </li>
              <!-- 核查员备注 -->
              <li class="flex15">
                {{ items.order_purchase.order_detail.p_remark }}
              </li>
            </ul>
          </div>
        </div>
        <!-- 底部 -->
        <div class="foot">
          <div class="item">
            <!-- 检品单备注： -->
            <h6>{{ $t("message.remarksOnInspectionList") }}:</h6>
            <el-input type="textarea" placeholder="请输入内容" v-model="datas.remark">
            </el-input>
          </div>
          <div class="item">
            <!-- 复检原因选择 -->
            <h6>
              {{ $t("message.selectionOfReasonsForReinspection") }}:
              <el-select v-model="datas.recheck_reason" placeholder="请选择" filterable size="small">
                <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </h6>
            <el-input type="textarea" placeholder="请输入内容" v-model="datas.recheck_reason_detail">
            </el-input>
          </div>
          <div class="item radio" v-if="id == 13 || id == 14 || id == 15 || id == 16 || id == 1196">
            <!-- 是否需要布标处理： -->
            <p>
              <span> {{ $t("message.whetherToClothLabels") }} :</span>
              <el-radio-group v-model="datas.is_need_label">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </p>
            <!-- 是否需要计算绩效： -->
            <p>
              <span>
                {{ $t("message.whetherPerformanceNeedsToBeCalculated") }}
                :</span>
              <el-radio-group v-model="datas.is_need_performance">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </p>
          </div>
          <div class="item">

            <!--  提出复检单-->
            <el-button type="primary" class="primary" @click="recheckInspectCreate"
              v-if="name != 'commodityInspection'">
              {{ $t("message.submitTheReinspectionList") }}
            </el-button>
            <el-button type="primary" class="primary" @click="recheckInspectCreateDirect"
              v-if="name == 'commodityInspection'">
              {{ $t("message.submitTheReinspectionList") }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array },
    type: { type: String },
  },
  data() {
    return {
      name: this.$route.name,
      datas: {
        remark: "",
        type: "",
        recheck_reason: "",
        recheck_reason_detail: "",
        is_need_label: 0,
        is_need_performance: 0,
        list: [],
      },
      options: [],
      id: JSON.parse(localStorage.getItem('japanUserRoleInfo')).id
    };
  },
  created() {
    console.log(this.list);
    this.$api.inspectionApi.recheckReasonMap().then((res) => {
      this.options = res.data;
    });
  },
  methods: {
    // 复检单创建
    recheckInspectCreate() {
      this.datas.list = [];
      this.type == "普检复检单" ? (this.datas.type = 1) : (this.datas.type = 2);
      this.list.forEach((item) => {
        item.inspect_detail.forEach((items) => {
          this.datas.list.push({
            id: items.id,
            num: items.reinspection_num,
          });
        });
      });
      this.$api.inspectionApi.recheckInspectCreate(this.datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.reinspectionDialogVisible = false;
        this.$parent.inspectList();

      });
    },
    // 商品复检单-复检单创建
    recheckInspectCreateDirect() {
      this.datas.list = [];
      this.type == "普检复检单" ? (this.datas.type = 1) : (this.datas.type = 2);
      this.list.forEach((item) => {
        item.inspect_detail.forEach((items) => {
          this.datas.list.push({
            order_purchase_id: items.order_purchase.order_detail.order_purchase_id,
            num: items.reinspection_num,
          });
        });
      });
      this.$api.inspectionApi.recheckInspectCreateDirect(this.datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.reinspectionDialogVisible = false;
        this.$parent.followList();

      });
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
}

.table {
  margin-top: 24px;

  ol {
    display: flex;
    font-size: 14px;

    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;
    margin-bottom: 20px;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }

  .infoBox {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 20px;
    border-bottom: solid 1px #d2d2d2;

    .info {
      margin-right: 40px;

      span {
        margin-right: 40px;
      }
    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
        width: 100%;
        max-height: 80px;
        overflow: hidden;
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
      }

      &:hover {
        .bigPic {
          display: block;
        }
      }

      .bigPic {
        position: absolute;
        right: -280px;
        top: -150px;
        z-index: 99;
        display: none;

        img {
          width: 300px;
          height: 300px;
        }
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .detail {
    .head {
      height: 60px;
      display: flex;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      a {
        color: #f0ef70;
      }

      .show {
        flex: 0.3;
        cursor: pointer;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 16px;
        }
      }

      .item {
        flex: 1;
        line-height: 20px;
        padding: 10px;

        span {
          margin-right: 30px;
        }
      }

      .order {
        flex: 1.5;
      }

      .name {
        flex: 3;
        line-height: 40px;
      }

      .lookRemark {
        text-align: right;
        line-height: 40px;
        margin-right: 14px;
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

.foot {
  margin: 24px 0;
  display: flex;

  .item {
    flex: 1;
    margin-right: 48px;

    &:nth-last-child(1) {
      margin-right: 0;
      text-align: right;
    }

    h6 {
      margin-bottom: 12px;
      font-size: 16px;
      line-height: px;
    }
  }

  .radio {
    p {
      margin-bottom: 30px;
      font-size: 16px;
      display: flex;

      span {
        width: 150px;
      }

      /deep/.el-radio__inner {
        transform: scale(1.5);
      }
    }
  }
}
</style>